import * as Api from '../utils/API';
import {
    ESPACOTRACK_EXCLUIR_NOTA,
    ESPACOTRACK_EXCLUIR_NOTA_LOADING,
    ESPACOTRACK_FORMULARIOS_LIST,
    ESPACOTRACK_FORMULARIOS_LIST_LOADING,
    ESPACOTRACK_FORMULARIO_OCULTAR,
    ESPACOTRACK_FORMULARIO_OCULTAR_LOADING,
    ESPACOTRACK_FORMULARIO_REMOVE,
    ESPACOTRACK_IMAGEM,
    ESPACOTRACK_IMAGEM_LOADING,
    ESPACOTRACK_LIBERACAO,
    ESPACOTRACK_LIBERACAO_LOADING,
    ESPACOTRACK_LIST,
    ESPACOTRACK_LOADING,
    ESPACOTRACK_PARCEIRO,
    ESPACOTRACK_PARCEIRO_LOADING,
    ESPACOTRACK_REMOVE,
    ESPACOTRACK_SHOW_OCULT,
    ESPACOTRACK_VENDEDORES,
} from '../actions/ActionsTypes';

export const EspacoTrackListAction = (userid, showOcult) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ESPACOTRACK_LOADING, payload: true });
        Api.getPedidos(userid, showOcult).then(dados => {
            dispatch({ type: ESPACOTRACK_LIST, payload: dados })
            dispatch({ type: ESPACOTRACK_LOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });

export const EspacoTrackVendedoresAction = (userid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        Api.getVendedores(userid).then(dados => {
            dispatch({ type: ESPACOTRACK_VENDEDORES, payload: dados })
            dispatch({ type: ESPACOTRACK_LOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });
export const EspacoTrackParceiroAction = (nunota, userid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ESPACOTRACK_PARCEIRO_LOADING, payload: true })
        Api.getParceiro(nunota, userid).then(dados => {
            dispatch({ type: ESPACOTRACK_PARCEIRO, payload: dados })
            dispatch({ type: ESPACOTRACK_PARCEIRO_LOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });

export const EspacoTrackExcluirAction = (nunota, ordemcarga, userid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        Api.postExcluirNota(nunota, ordemcarga, userid).then(dados => {
            dispatch({ type: ESPACOTRACK_EXCLUIR_NOTA, payload: dados })
            // dispatch({ type: ESPACOTRACK_REMOVE, payload: dados });
            EspacoTrackListAction(userid)
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });

export const EspacoTrackShowOcult = (show) => (dispatch) => {


    dispatch({ type: ESPACOTRACK_SHOW_OCULT, payload: show === 1 ? 1 : 0 })
}

export const removerEntregaLocal = (nunota) => (dispatch) => {
    new Promise(function (resolve, reject) {
        console.log('chegou aqui nota ->', nunota)
        dispatch({ type: ESPACOTRACK_REMOVE, payload: nunota });
    });
};

export const EspacoTrackFormulariosListAction = (codvend, codparc, nunota, showOcult = 0) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ESPACOTRACK_FORMULARIOS_LIST_LOADING, payload: true })
        Api.getFormularios(codvend, codparc, nunota, showOcult).then(dados => {
            dispatch({ type: ESPACOTRACK_FORMULARIOS_LIST, payload: { dados, showOcult } })
            dispatch({ type: ESPACOTRACK_FORMULARIOS_LIST_LOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });

export const EspacoTrackPostLiberacaoAction = (codusu, idfec, justificativa) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ESPACOTRACK_LIBERACAO_LOADING, payload: true })
        Api.postLiberacao(codusu, idfec, justificativa).then(dados => {
            dispatch({ type: ESPACOTRACK_LIBERACAO, payload: dados })
            dispatch({ type: ESPACOTRACK_LIBERACAO_LOADING, payload: false })
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const EspacoTrackGetImagemAction = (idfec) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ESPACOTRACK_IMAGEM_LOADING, payload: true })
        Api.getImagem(idfec).then(dados => {
            dispatch({ type: ESPACOTRACK_IMAGEM, payload: dados })
            dispatch({ type: ESPACOTRACK_IMAGEM_LOADING, payload: false })
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const EspacoTrackFormularioOcultarAction = (idfec) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ESPACOTRACK_FORMULARIO_OCULTAR_LOADING, payload: true })
        Api.postFormularioOcultar(idfec).then(dados => {
            dispatch({ type: ESPACOTRACK_FORMULARIO_OCULTAR, payload: dados })
            dispatch({ type: ESPACOTRACK_FORMULARIO_OCULTAR_LOADING, payload: false })

            if (dados?.[0]?.status === 'OK') {
                dispatch({ type: ESPACOTRACK_FORMULARIO_REMOVE, payload: idfec })
            }

            resolve(dados)
        }).catch(error => {
            dispatch({ type: ESPACOTRACK_FORMULARIO_OCULTAR_LOADING, payload: false })
            reject(error);
        })
    });
